<div class="table-container">
  @if (data) {
    <p-table [value]="data.data" [scrollable]="true" class="table" class="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>NOME</th>
          <th>TELEFONE</th>
          <th>FUNÇÃO</th>
          <th>AÇÕES</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-employee let-rowIndex="rowIndex as number">
        <tr>
          <td>{{ employee.id }}</td>
          <td>{{ employee.email }}</td>
          <td>{{ employee.phone }}</td>
          <td>
            {{ employee.role | collaboratorRoleEnum }}
            @if (employee.sales_limit_cents) {
              <div>
                {{
                  employee.cash_limit_action === "block_sales"
                    ? "Limite: avisa e bloqueia novas vendas"
                    : "Limite: somente avisa"
                }}
              </div>
            }
            @if (
              employee.role === "pdv_portaria" ||
              ((employee.role === "pdv_portaria_coordenador" || employee.role === "manager") &&
                employee.coordinator_profile === "also_operates")
            ) {
              <div>
                {{
                  employee.pdv_sales_scope === "advance_and_portaria" ? "Antecipados + portaria" : "Somente portaria"
                }}
              </div>
            }
            @if (employee.role === "pdv_portaria_coordenador" || employee.role === "manager") {
              <div>
                {{
                  employee.coordinator_profile === "also_operates"
                    ? "Autoriza com PIN e também vende"
                    : "Somente autoriza com PIN"
                }}
              </div>
            }
            @if (employee.role === "manager" || employee.role === "pdv_portaria_coordenador") {
              <div>{{ employee.pin_set ? "PIN configurado" : "Sem PIN configurado" }}</div>
            }
          </td>

          <td>
            @if (!readOnly) {
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                @if (employee.role !== "seller" && employee.role !== "point_of_sale") {
                  <button mat-menu-item (click)="editPdvPermission.emit(employee)">
                    <mat-icon>edit</mat-icon><span>Editar cargo e acessos</span>
                  </button>
                }
                <button mat-menu-item (click)="removeEmployeeClick.emit(employee)">
                  <mat-icon>delete</mat-icon>
                  <span>Remover colaborador</span>
                </button>
              </mat-menu>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator
      (onPageChange)="pageChange.emit($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="data.meta.total_count || 0"
      [showCurrentPageReport]="false"
      [showPageLinks]="false"
      [showJumpToPageDropdown]="false"
      [rowsPerPageOptions]="[10, 20, 30]"
      currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
  } @else {
    <p-skeleton height="360px" />
  }
</div>
